var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`card border-${_vm.color}`},[_c('div',{staticClass:"card-body d-flex justify-content-between"},[_c('div',[_c('div',[_c('strong',[_vm._v(_vm._s(_vm.value))])]),_c('div',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('fa-icon',{attrs:{"icon":_vm.icon,"size":"2x"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }